import { render, staticRenderFns } from "./SchulenList.vue?vue&type=template&id=13f4487e&"
import script from "./SchulenList.vue?vue&type=script&lang=js&"
export * from "./SchulenList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports